<section class="settingsSection">
  @if (ppOptions && !ppOptions.skipHeader) {
    <header
      class="settingsSection__header"
      [ngClass]="{ 'settingsSection__header--small-padding': ppOptions.headerPaddingSmall }"
      >
      <h5
        class="settingsSection__header-title"
        [ngClass]="{ 'settingsSection__header--full-width': ppOptions.headerWidthFull }"
        >
        <ng-content select="[title]"></ng-content>
      </h5>
      <div class="settingsSection__header-right">
        <ng-content select="[titleBar-right]"></ng-content>
      </div>
    </header>
  }

  <div class="settingsSection__body" [ngClass]="gridClass">
    <ng-content select="[body]"></ng-content>
  </div>
</section>
